<div [formGroup]="form">
<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">rule</mat-icon>
        <span>Tributação Regular</span>
        <div class="section-title-actions ms-auto">
            <button mat-button type="button" class="btn-section" [matBadge]="personalizadasCount" [matBadgeHidden]="personalizadasCount === 0" (click)="abrirEditorFormulas()">
                <mat-icon class="material-symbols-outlined">settings</mat-icon>
                Personalizar fórmulas
            </button>
        </div>
    </div>

    <div class="row g-3">
        <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>CST</mat-label>
                <mat-select formControlName="cstIbsCbs">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (cst of csts; track cst.codigo) {
                    <mat-option [value]="cst.codigo">{{ cst.codigo }} - {{ cst.descricao }}</mat-option>
                    }
                </mat-select>
                <mat-error>Informe o CST, o cClassTrib e as alíquotas efetivas da tributação regular.</mat-error>
            </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Classificação Tributária (cClassTrib)</mat-label>
                <mat-select formControlName="cclassIbsCbs">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (cclass of cclasstribs; track cclass.codigo) {
                    <mat-option [value]="cclass.codigo">{{ cclass.codigo }} - {{ cclass.descricao }}</mat-option>
                    }
                </mat-select>
                <mat-error>Informe o CST, o cClassTrib e as alíquotas efetivas da tributação regular.</mat-error>
            </mat-form-field>
        </div>

        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota efetiva IBS UF (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pAliqEfetivaIbsUf">
                <mat-error>{{ form.get('pAliqEfetivaIbsUf')?.hasError('min') ? 'A alíquota efetiva do IBS UF da tributação regular deve estar entre 0 e 100.' : 'Informe o CST, o cClassTrib e as alíquotas efetivas da tributação regular.' }}</mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota efetiva IBS Município (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pAliqEfetivaIbsMunicipio">
                <mat-error>{{ form.get('pAliqEfetivaIbsMunicipio')?.hasError('min') ? 'A alíquota efetiva do IBS município da tributação regular deve estar entre 0 e 100.' : 'Informe o CST, o cClassTrib e as alíquotas efetivas da tributação regular.' }}</mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota efetiva CBS (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pAliqEfetivaCbs">
                <mat-error>{{ form.get('pAliqEfetivaCbs')?.hasError('min') ? 'A alíquota efetiva da CBS da tributação regular deve estar entre 0 e 100.' : 'Informe o CST, o cClassTrib e as alíquotas efetivas da tributação regular.' }}</mat-error>
            </mat-form-field>
        </div>
    </div>
</div>
</div>
